import React from 'react'
import PropTypes from 'prop-types'
// import { BlogPostTemplate } from '../../templates/blog-post'
// import { BlogPost } from '../../templates/blog-post'
import BlogPostTemplate from '../../components/BlogPostTemplate'

    // <BlogPostTemplate
  //   content={widgetFor('body')}
  //   date={entry.getIn(['data', 'date'])}
  //   title={entry.getIn(['data', 'title'])}
  //   address={entry.getIn(['data', 'address'])}
  //   position={entry.getIn(['data', 'position'])}
  //   priceClass={entry.getIn(['data', 'priceClass'])}
  //   website={entry.getIn(['data', 'website'])}
  //   description={entry.getIn(['data', 'description'])}
  //   tags={entry.getIn(['data', 'tags'])}
  //   image={entry.getIn(['data', 'image'])}
  //   categories={entry.getIn(['data', 'categories'])}
  // />

const BlogPostPreview = ({ entry, widgetFor }) => (
  <div>Date: {entry.getIn(['data', 'date'])}</div>
)

BlogPostPreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  widgetFor: PropTypes.func,
}

export default BlogPostPreview

